import { NEDGLOBE_MAP_RESOLUTION, INTERFACE_PANEL_TRIGGERS } from '../../../../constants';

export const getters = {
    getMainMap: state => state.defaultMap,
    getPanelGroup: (state) => (groupName) => {
        return Object.entries(state.uiElements)
            .filter(([, value]) => value.position !== undefined)
            .filter(([, value]) => !groupName || value.position === groupName);
    },
    isLeftPanelVisible: (state, _getters) => (
        _getters.getPanelGroup('left').find(([, value]) => value.visible) ||
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].components.detailPanel.visible
    ),
    getDetailInformationPanelHeight: (state, _getters) => (
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].height
    ),
    getDetailInformationPanelWidth: (state, _getters) => (
        state.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION].width
    ),
    mapIsInSelectableRangeForTerugmeldingen: (state, _getters) => {
        const currentResolution = _getters.getMainMap.map.getView().getResolution();
        const resolutions = NEDGLOBE_MAP_RESOLUTION;

        return currentResolution <= resolutions[13];
    },
    getLocale: state => state.userData.locale,
    getClickedInRangeForWebfeedback: (state, _getters) => {
        return state.clickedInRangeForWebfeedback;
    },
    getAllOrderedLayersIds: (state, _getters) => {
        return state.layers
            .sort((layera, layerb) => {
                return layera.data.order - layerb.data.order;
            })
            .map(({ id }) => id);
    },
    getAllOrderedLayers: (state, _getters) => {
        return [
            ...state.layers
        ];
    },
    getIsInAccessibleMode: state => state.accessibility.enabled,
    getWebInformationPanelHeight: state => state.uiElements[INTERFACE_PANEL_TRIGGERS.WEB_INFORMATION].height,
    getAdvancedSearchPanelHeight: state => state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].height,
    getAdvancedSearchPanelWidth: state => state.uiElements[INTERFACE_PANEL_TRIGGERS.ADVANCED_SEARCH].width,
    getWelcomePanelDontShow: state => state.uiElements[INTERFACE_PANEL_TRIGGERS.WELCOME_PANEL].dontShowAgain,
    getScales: state => state.scales
};
